/**
 * Genesis Event Types
 *
 * Type definitions for the Genesis Event celebration feature.
 * This feature triggers when a user views their first-ever note after creating it from the plugin.
 */

/**
 * Phases of the Genesis Event celebration
 */
export enum GenesisPhase {
  /** Initial state - not yet started */
  IDLE = 'idle',
  /** Celebration - confetti and achievement card */
  CELEBRATION = 'celebration',
  /** Integration - settling and fade out */
  INTEGRATION = 'integration',
  /** Completed - event has finished */
  COMPLETE = 'complete',
}

/**
 * Eligibility state for triggering the Genesis Event
 */
export interface GenesisEligibility {
  /** Whether the user is eligible to see the Genesis Event */
  eligible: boolean;
  /** Whether eligibility check is still loading */
  loading: boolean;
  /** Reason for ineligibility (for debugging) */
  reason?: string;
}

/**
 * Color palette for the Genesis Event
 */
export const GENESIS_COLORS = {
  primary: '#6366f1', // Indigo
  secondary: '#8b5cf6', // Purple
  accent: '#f59e0b', // Amber/Gold
  glow: 'rgba(99, 102, 241, 0.5)',
  confetti: ['#6366f1', '#8b5cf6', '#f59e0b', '#ec4899', '#06b6d4', '#FFD700'],
  holographic: 'linear-gradient(135deg, #ff0080, #ff8c00, #40e0d0, #ff0080)',
} as const;

/**
 * Firestore field name for tracking Genesis Event completion
 */
export const GENESIS_FIRESTORE_FIELD = 'genesisEventCompleted';

/**
 * SessionStorage key for tracking plugin navigation
 */
export const PLUGIN_SESSION_KEY = 'cameFromPlugin';

/**
 * LocalStorage key for Genesis Event completion (backup to Firestore)
 */
export const GENESIS_LOCAL_STORAGE_KEY = 'genesisEventCompleted';

/**
 * URL query parameter to force trigger the celebration (for testing/demos)
 * Usage: ?celebrate=firstvideo
 */
export const GENESIS_FORCE_PARAM = 'celebrate';
export const GENESIS_FORCE_VALUE = 'firstvideo';
